import * as $ from 'jquery';
import {Global} from '../init-global';

require('jquery-debounced-and-throttled-resize/jquery.debouncedresize.js');
import { TweenLite, TimelineLite, Sine, Power3, Elastic, Back } from 'gsap';
const activated = [ TweenLite, TimelineLite, Sine, Power3, Elastic, Back ];
require('../vendor/MorphSVGPlugin.js');




export class RecyclingLoopAnimation {

    protected $root:JQuery;
    protected isMobile: boolean;
    protected breakpoint:number = 768;



    constructor(elem: HTMLElement)
    {
        this.$root = $(elem);
        this.bindUI();
    }

    private bindUI = () => {
       /* // Try a test
        let tween:TweenLite;
        let opacity = false;
        let motionPath = MorphSVGPlugin.pathDataToBezier("#motionPath", { align:"#balloon" });

        TweenLite.set("#balloon", {xPercent:-50, yPercent:-50});

        tween = TweenLite.to("#balloon", 2, {bezier:{values:motionPath, type:"cubic"} });
          */

        this.refreshViewport();

        $(window).on('debouncedresize', () => this.refreshViewport());
    }

    private initDesktop = () => {
       
    }

    private initMobile = () => {
       	
    }

    private refreshViewport = () => {
        let vp = Global.getViewport();
        let dspForMobile:boolean = (vp.width < this.breakpoint) ? true: false;

        if (dspForMobile != this.isMobile) {
            this.isMobile = dspForMobile;
            (this.isMobile) ? this.initMobile(): this.initDesktop();
        }
    }
}